export default "__VITE_ASSET__DH0oeKGW__"